import React, { useState, useEffect } from "react";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { RevenueCharts } from "./DashboardEcommerceCharts";
import CountUp from "react-countup";
import { useSelector, useDispatch } from "react-redux";
import { getRevenueChartsData } from "../../slices/thunks";
import { createSelector } from "reselect";
import moment from "moment"
import Flatpickr from "react-flatpickr";
import { getApiReport, getAPIStatus } from "../../helpers/fakebackend_helper";

const Revenue = () => {
  const dispatch = useDispatch();

  const [chartData, setchartData] = useState([]);
  const [fromDate, setFromDate] = useState(moment().subtract(7, "days"))
  const [toDate, setToDate] = useState(moment())
  const [categories, setCategories] = useState([])
  const [loading, setLoading] = useState(true)
  const [apiStatus, setApiStatus] = useState({ total: 0, total_success: 0, total_failed: 0, total_processing: 0 })
  // Inside your component

  useEffect(() => {
    // setFromDate(moment().subtract(7, "days"));
    // setToDate(moment())
    loadAPIStatus(fromDate, toDate)
  }, [])


  const onChangeChartPeriod = pType => {
    dispatch(getRevenueChartsData(pType));
  };
  const loadAPIStatus = async (from, to) => {
    setLoading(true)
    const response = await getApiReport(from.toISOString(), to.toISOString())
    console.log(response)
    var tmp = from;
    const tmpCategories = []
    const successData = {
      name: "Success",
      type: "line",
      data: []
    }
    const failedData = {
      name: "Failed",
      type: "line",
      data: []
    }
    const processingData = {
      name: "Processing",
      type: "line",
      data: []
    }
    while (tmp < to) {
      tmpCategories.push(tmp.format("DD MMM YY"))

      var exist = false;
      for (var i = 0; i < response.data.length; i++) {
        const data = response.data[i];
        if (moment(data.at_date).format("DD MMM YY") == tmp.format("DD MMM YY")) {

          console.log(moment(data.at_date).format("DD MMM YY"))
          successData.data.push(data.total_success)
          failedData.data.push(data.total_failed)
          processingData.data.push(data.total_processing)
          exist = true;
        }
      }
      if (!exist) {
        successData.data.push(0)
        failedData.data.push(0)
        processingData.data.push(0)
      }
      tmp = tmp.add(1, "day")
    }
    const chartTmp = [processingData, successData, failedData]
    setchartData(chartTmp)
    setCategories(tmpCategories)
    bindRangeStatus(response)
    console.log(response)
    setLoading(false)
  }
  const bindRangeStatus = (response) => {
    const tmpStatus = {
      total: 0,
      total_success: 0,
      total_failed: 0,
      total_processing: 0
    }
    for (var i = 0; i < response.data.length; i++) {
      const data = response.data[i];

      tmpStatus.total += Number(data.total_success)
      tmpStatus.total += Number(data.total_failed)
      tmpStatus.total += Number(data.total_processing)

      tmpStatus.total_success += Number(data.total_success)
      tmpStatus.total_failed += Number(data.total_failed)
      tmpStatus.total_processing += Number(data.total_processing)

    }
    setApiStatus(tmpStatus)
  }
  const pickDateChange = (values) => {
    if (values.length < 2) {
      return;
    }
    const from = moment(values[0])
    const to = moment(values[1])
    setFromDate(from)
    setToDate(to)
    loadAPIStatus(from, to)
    // console.log(event)
  }
  useEffect(() => {
    dispatch(getRevenueChartsData("all"));
  }, [dispatch]);
  return (
    <React.Fragment>
      <Card>
        <CardHeader className="border-0 align-items-center d-flex">
          <h4 className="card-title mb-0 flex-grow-1">API request</h4>
          <div className="d-flex gap-1">
            <div className="col-sm-auto">
              <div className="input-group">
                <Flatpickr
                  className="form-control border-0 dash-filter-picker shadow"
                  onChange={pickDateChange}
                  options={{
                    mode: "range",
                    dateFormat: "d M Y",
                    defaultDate: [fromDate.format("DD MMM YYYY"), toDate.format("DD MMM YYYY")]
                  }}
                />
                <div className="input-group-text bg-primary border-primary text-white"><i className="ri-calendar-2-line"></i></div>
              </div>
            </div>
          </div>
        </CardHeader>

        <CardHeader className="p-0 border-0 bg-light-subtle">
          <Row className="g-0 text-center">
            <Col xs={6} sm={3}>
              <div className="p-3 border border-dashed border-start-0">
                <h5 className="mb-1">
                  <CountUp start={0} end={apiStatus.total} duration={3} separator="," />
                </h5>
                <p className="text-primary mb-0">Total API request</p>
              </div>
            </Col>
            <Col xs={6} sm={3}>
              <div className="p-3 border border-dashed border-start-0">
                <h5 className="mb-1 text-success">
                  <CountUp
                    start={0}
                    end={apiStatus.total_success}
                    duration={3}
                  />
                </h5>
                <p className="text-success mb-0">Total Success</p>
              </div>
            </Col>
            <Col xs={6} sm={3}>
              <div className="p-3 border border-dashed border-start-0">
                <h5 className="mb-1 text-warning">
                  <CountUp start={0} end={apiStatus.total_processing} duration={3} />
                </h5>
                <p className="text-warning mb-0">Processing</p>
              </div>
            </Col>
            <Col xs={6} sm={3}>
              <div className="p-3 border border-dashed border-start-0 border-end-0">
                <h5 className="mb-1 text-danger">
                  <CountUp
                    start={0}
                    end={apiStatus.total_failed}
                    duration={3}
                  />
                </h5>
                <p className="text-danger mb-0">Total failed</p>
              </div>
            </Col>
          </Row>
        </CardHeader>

        <CardBody className="p-0 pb-2">
          <div className="w-100">
            <div dir="ltr">
              {
                loading ? null :
                  <RevenueCharts series={chartData} categories={categories} dataColors='["#a78bfa", "#10d182", "#f97373"]' />
              }
            </div>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default Revenue;
